// src/styles/themes/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
palette: {
    primary: {
      main: '#0C343D', // Color primario personalizado
    },
    secondary: {
      main: '#00bcd4', // Color secundario personalizado
    },
    background: {
      default: '#f5f5f5', // Color de fondo predeterminado
    },
    sidebar: {
      background: '#071E24',
      text: '#90A4AE',
      activeText: '#FFFFFF',
      activeItem: 'rgba(0,188,212,0.15)',
      hoverItem: 'rgba(255,255,255,0.05)',
      sectionLabel: 'rgba(255,255,255,0.45)',
      divider: 'rgba(255,255,255,0.08)',
      userCardBg: 'rgba(255,255,255,0.04)',
    },
},
typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', // Tipografia global
    h1: {
    fontSize: '2rem',
    fontWeight: 700,
    },
    // Puedes personalizar otros estilos tipograficos
},
components: {
    MuiButton: {
    styleOverrides: {
        root: {
          borderRadius: 8, // Cambia el radio de las esquinas de todos los botones
          textTransform: 'none', // Evita que el texto se convierta en mayusculas
        },
    },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          // Los estilos del sidebar oscuro se aplican via sx en SidebarComponent
        },
      },
    },
    // Puedes sobrescribir estilos de otros componentes
},
});

export default theme;
